import BasicInfo from '../../Common/BasicInfo';
import Quoter from './Quoter';
import Beneficiary from './Beneficiary';
import PersonalHistory from './PersonalHistory';
import MedicalHistory from './MedicalHistory';
import PolicyPurposeConfirmation from './PolicyPurposeConfirmation';
import UnderwritingStatus from './UnderwritingStatus';
import AgreementToUnderwriting from './AgreementToUnderwriting';
import FinancialInformation from './FinancialInformation';
import Appointment from '../../Common/Appointment/Appointment';
import Offer from './Offer';
import Sign from '../../Common/Sign';
import Status from './Status';
import Ineligible from './Ineligible';
import PersonalInfo from './PersonalInfo';
import GettingToKnowYou from './GettingToKnowYou';
import IdentityVerification from './IdentityVerification';
import GettingStarted from './GettingStarted';

export {
  BasicInfo,
  Quoter,
  PersonalInfo,
  GettingToKnowYou,
  IdentityVerification,
  Beneficiary,
  PersonalHistory,
  MedicalHistory,
  PolicyPurposeConfirmation,
  UnderwritingStatus,
  AgreementToUnderwriting,
  FinancialInformation,
  Appointment,
  Offer,
  Sign,
  Status,
  Ineligible,
  GettingStarted
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/index.js